<template>
    <section class="rr-topbar">
        <div class="rrtb-logo"></div>
        <div class="rrtb-buttons">
            <div class="rrtb-button"><Button link><b>Proč&nbsp;<span class="rr-primary-color">roori</span>?</b></Button></div>
            <div class="rrtb-button"><Button link><b>Ceník</b></Button></div>
            <div class="rrtb-button"><Button link><b>Reference</b></Button></div>
            <div class="rrtb-button"><Button link><b>Kontakt</b></Button></div>
            <div class="rrtb-login"><Button label="Vstoupit" @click="$router.push('/login')"/></div>
        </div>
    </section>
</template>
<script>
import Button from 'primevue/button';
export default {
    name: "TopBar",
    components: {
        Button
    }
}
</script>
<style scoped lang="scss">
.rr-topbar, .rrtb-buttons {
    width: 100%;
    display: flex;
    justify-content: flex-end;
    align-items: center;
    gap: 15px;
}

.rr-topbar {
    margin-bottom: 20px;
}
.rrtb-logo {
    width: 145px;
    height: 50px;
    background-image: url("../../../../assets/images/logo.svg");
    background-repeat: no-repeat;
    background-position: center;
}
</style>
